import { render, staticRenderFns } from "./PriceGuardButton.vue?vue&type=template&id=5b7d997e&scoped=true"
import script from "./PriceGuardButton.vue?vue&type=script&lang=js"
export * from "./PriceGuardButton.vue?vue&type=script&lang=js"
import style0 from "./PriceGuardButton.vue?vue&type=style&index=0&id=5b7d997e&lang=scss&scoped=true"
import style1 from "./PriceGuardButton.vue?vue&type=style&index=1&id=5b7d997e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7d997e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b7d997e')) {
      api.createRecord('5b7d997e', component.options)
    } else {
      api.reload('5b7d997e', component.options)
    }
    module.hot.accept("./PriceGuardButton.vue?vue&type=template&id=5b7d997e&scoped=true", function () {
      api.rerender('5b7d997e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Home/PriceGuardButton.vue"
export default component.exports